import { StyleRulesCallback, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import React from "react";

import { ProgressionBar } from "../../../../../components/ProgressionBar";
import { TopBarPortal } from "../../../../../components/TopBarPortal";

const styles: StyleRulesCallback = (theme: Theme) => ({
  container: {
    left: 0,
    position: "absolute",
    right: 0,
    zIndex: theme.zIndex.appBar
  }
});

export interface IProps extends WithStyles<typeof styles> {
  loading: boolean;
}

const BaseLoadingBar: React.FC<IProps> = ({ classes, loading }) => (
  <TopBarPortal>
    <div className={classes.container}>
      <ProgressionBar loading={loading} />
    </div>
  </TopBarPortal>
);

export const LoadingBar = withStyles(styles)(BaseLoadingBar);
